import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TimeInterval } from 'src/app/core/constants/types.constants';

@Component({
    selector: 'app-time-intervals',
    templateUrl: './time-intervals.component.html',
    styleUrls: ['./time-intervals.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeIntervalsComponent {
    @Output() timeIntervalEvent = new EventEmitter<TimeInterval>();
    @Input() activeInterval: TimeInterval = '7D'; // Default is set to 7D
    intervals: TimeInterval[] = ['1D', '7D', '1M', '3M', '1Y'];

    changeInterval(interval: TimeInterval) {
        this.activeInterval = interval;
        this.timeIntervalEvent.emit(this.activeInterval);
    }
}
